import { useEffect, useState } from "react";
import { getSaleOnTheTable } from "../services/promo.service";

export const usePromo = () => {
  const [promoData, setPromoData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromo = async () => {
      const banners = await getSaleOnTheTable();

      // skip first banner if needed
      setPromoData(banners.slice(1));
      setLoading(false);
    };

    fetchPromo();
  }, []);

  return { promoData, loading };
};